// extracted by mini-css-extract-plugin
module.exports = {"alert":"appointments__ServiceTypeInfo__alert"};